import { usePromisedRequest } from "../Common/request";
import { User } from "../Common/types";
import { resolveNoContent, resolveWithBody } from "./Utils/utils";

export type CreateVoucherRequest = {
    eventId: number;
    max: number;
};

export type FullVoucherData = {
    id: number;
    code: string;
    max: number;
    amountUsed: number;
    created: string;
    modified: string;
    receiver: User | null;
};

export type AcquireVoucherRequest = {
    eventId: number;
    code: string;
};

export type AcquireResponse = {
    success: boolean;
    max: number;
    amountUsed: number;
};

export type VoucherPaymentConfirmationRequest = {
    eventId: number;
    code: string;
    eventRegistrationIds: number[];
};

export default {
    // MANAGEMENT
    createVoucher(request: CreateVoucherRequest): Promise<void> {
        return usePromisedRequest<void>({
            url: `/api/admin/events/${request.eventId}/vouchers`,
            method: "post",
            json: request,
        }).then(resolveNoContent());
    },
    getVouchersListing(eventId: number): Promise<FullVoucherData[]> {
        return usePromisedRequest<FullVoucherData[]>({
            url: `/api/admin/events/${eventId}/vouchers`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    deleteVoucher(eventId: number, voucherId: number): Promise<void> {
        return usePromisedRequest<void>({
            url: `/api/admin/events/${eventId}/vouchers/${voucherId}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },

    //USING
    acquireVoucher(request: AcquireVoucherRequest): Promise<AcquireResponse> {
        return usePromisedRequest<AcquireResponse>({
            url: `/api/events/${request.eventId}/vouchers`,
            method: "post",
            json: request,
        }).then(resolveWithBody());
    },
    confirmPaymentsWithVoucher(request: VoucherPaymentConfirmationRequest): Promise<void> {
        return usePromisedRequest<void>({
            url: `/api/events/${request.eventId}/vouchers/confirm-payments`,
            method: "post",
            json: request,
        }).then(resolveNoContent());
    },
};
